import { Navigate } from 'react-router-dom';
import LoadingComponent from '../../../Components/Shared/LoadingComponent';
import WSA from '../../../WSA';
import { useRouteDebounce } from '../../navigationHooks';
import { paths } from '../../paths';

const VerifyRoute = ({ children }) => {
  const { isAuthenticated, needsVerification } = WSA.Components.useWSAuth();

  const needsDebounce = !isAuthenticated || needsVerification;
  const debounceString = JSON.stringify({
    isAuthenticated,
    needsVerification,
  });
  const isDebounced = useRouteDebounce(debounceString, needsDebounce);

  if (!isDebounced) {
    return <LoadingComponent />;
  } else if (isAuthenticated) {
    // ready and autheticated
    if (needsVerification) {
      return <>{children}</>;
    } else {
      return <Navigate to={paths.setup} replace />;
    }
  } else {
    // not authenticated, go to signin
    return <Navigate to={paths.signin} />;
  }
};
export default VerifyRoute;
